<template>
  <!-- <dv-border-box-12> -->
    <div id="centerRight2">
      <div class="bg-color-black">
        <div class="d-fle title11">
          <!-- <span>
            <icon name="align-left" class="text-icon"></icon>
          </span> -->
          <span class="fs-xl text_title commonTitle">报废织物排名</span>
        </div>
        <div class="d-flex flex-column body-box title22">
          <!-- <dv-capsule-chart class="dv-cap-chart" :config="config" /> -->
          <!-- <centerRight2Chart1 /> -->
          <div class="d-flex d-title flexEnd">
            <!-- <div class=" d-flex jc-end fz17 bfsl"></div> -->
            <div class="d-flex jc-end fz17 commonText" style="width: 100%;">
              <div class="w50"></div>
              <div class="w25">报废数量</div>
              <div class="w25">平均洗涤寿命</div>
            </div>
          </div>
          <div class="d-flex table-list">
            <vue-seamless-scroll
              :key="scrollKey"
              :data="listData"
              :class-option="defineScroll"
              class="warp"
              ref="scroll3"
            >
            <ul class="item">
              <li v-for="(item, index) in result" :key="index">
                <span class="index" >
                  <span class="orange">No.{{ index+1 }} <span class="name" v-text="item.spuName"></span></span>
                  <span class="line" :style="{ width: item.rate + '%' }"></span>
                </span>
                <span class="num" v-text="item.num"></span>
                <span class="numWashing" v-text="item.numWashing"></span>
              </li>
            </ul>
          </vue-seamless-scroll>
          </div>
        </div>
        <div class="d-flex jc-center text-info-1 fs-lg title33 commonText totalBottom">
          报废总数：{{ total }}
        </div>
      </div>
    </div>
  <!-- </dv-border-box-12> -->
</template>

<script>
// import centerRight2Chart1 from '@/components/echart/centerRight/centerRightChart'
import * as api from '@/api/index'
export default {
  computed: {
    defineScroll() {
      return {
        step: 0.08,
        singleHeight: 0,
        waitTime: 0,
        hoverStop: true,
        direction: 1,
        openWatch: true,
      };
    },
  },
  data() {
    return {
      listData: [
        {
          title: "item-1",
          date: "2017-12-16",
        },
        {
          title: "鏃犵紳婊氬姩绗簩琛屾棤缂濇粴鍔ㄧ浜岃",
          date: "2017-12-16",
        },
        {
          title: "鏃犵紳婊氬姩绗笁琛屾棤缂濇粴鍔ㄧ涓夎",
          date: "2017-12-16",
        },
        {
          title: "鏃犵紳婊氬姩绗洓琛屾棤缂濇粴鍔ㄧ鍥涜",
          date: "2017-12-16",
        },
        {
          title: "鏃犵紳婊氬姩绗簲琛屾棤缂濇粴鍔ㄧ浜旇",
          date: "2017-12-16",
        },
        {
          title: "鏃犵紳婊氬姩绗叚琛屾棤缂濇粴鍔ㄧ鍏",
          date: "2017-12-16",
        },
        {
          title: "鏃犵紳婊氬姩绗竷琛屾棤缂濇粴鍔ㄧ涓冭",
          date: "2017-12-16",
        },
        {
          title: "鏃犵紳婊氬姩绗叓琛屾棤缂濇粴鍔ㄧ鍏",
          date: "2017-12-16",
        },
        {
          title: "鏃犵紳婊氬姩绗節琛屾棤缂濇粴鍔ㄧ涔濊",
          date: "2017-12-16",
        },
      ],
      total: 0,
      config: {
        waitTime: 5000,
        data: [
          {
            name: '鍥藉唴',
            value: 167
          },
          {
            name: '娴峰',
            value: 67
          },
          {
            name: 'total',
            value: 234
          },
        ]
      },
      colors: ['red', '#e55132', '#dd752e', '#e7a649', '#96d70f'],
      params: {
        pageNum: 1,
        pageSize: 10,
        startTime: '',
        endTime: '',
        customerId: ''
      },
      result: [],
      scrollKey: 0,
      intervalId: null // 鐢ㄤ簬瀛樺偍瀹氭椂鍣ㄧ殑 ID
    }
  },
  // components: { centerRight2Chart1 }
  mounted() {
    this.params.customerId = this.$route.query.customerId
    if (this.$refs.scroll3 && this.$refs.scroll3._cancle) {
      this.$refs.scroll3._cancle()
    }
    this.getData()
    
    this.intervalId = setInterval(() => {
      this.getData()
    }, 30 * 60 * 1000)
  },
  
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
  methods: {
    async getData() {
      const res = await api.getBigSkuDispose(this.params)
      console.log(res.Result, '缁囩墿鎶ュ簾-----------')
      if (res.ResultCode == 0) {
        this.result = res.Result.sort(function (a, b) {
          return b.num - a.num; // 浠庡ぇ鍒板皬鎺掑簭
        })
        this.total = res.Result.reduce((pre, ctx) => pre + ctx.num, 0)

        this.result = this.result.map(item => {
          item.rate = item.num / this.total * 100
          return item
        })
        let that = this
        setTimeout(() => {
          that.listData = that.result
          that.scrollKey += 1
          that.$nextTick(() => {
            if (that.$refs.scroll3 && that.$refs.scroll3.reset) {
              that.$refs.scroll3.reset()
            }
          })
        }, 5000);

        // let tempdata =  res.Result.sort(function (a, b) {
        //   return b.num - a.num; // 浠庡ぇ鍒板皬鎺掑簭
        // }).map(v => {
        //   return {
        //     name: v.spuName,
        //     value: v.num,
        //   }
        // });

        // console.error('tempdata',tempdata)

        // this.config = { waitTime: 5000, unit: '銋ゃ叅銆€', data : tempdata  }

        // console.error(this.config)

        
        // this.config.data.forEach((item,index) => {
        //   this.result.forEach((item2,index2) =>{
        //     if(index == index2){
        //       let str = '銆€銆€銆€銆€銆€銆€銆€銆€銆€銋ゃ叅銆€銆€銆€銆€銆€銆€銋ゃ叅銋?
        //       item.name = item.name.replace(/[()]/g, match => match === '(' ? '锛? : '锛?).replace(/\s+/g, '');
        //       let length = str.length -  item.name.toString().length
        //       str = '銆€'.repeat(length) // 'aaa'
        //       this.config.data[index].name = item.name + '' + str + item.value

        //       item.value = item2.numWashing
        //     }
        //   })
          
        // });

        // console.log(this.result, 'this.result---------')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
#centerRight2 {
 // $box-height: 410px;
 // $box-width: 500px;
  //padding: 16px;
  // height: $box-height;
  width: 100%;
  height: 100%!important;
  border-radius: 5px;
  padding-bottom: 0px;

  ::v-deep .dv-scroll-ranking-board .ranking-info .ranking-value {
    // display: none;
  }

  ::v-deep  .ranking-column {
     border: none;
    margin-bottom: -5px;
    margin-top: 0px;
    .inside-column {
      background-color: #e77d35;
    }
    .row-item{
      height: 24px!important;
    }
  }

  .ul_item {
    //height: 180px;
    overflow-y: auto;

    li {
      padding:0 10px 0 10px;
      align-items: center;
      text-align: center;
      .numWashing{
        font-size: 14px;
        display: inline-block;
        width: 100%;
        color:#00cdff;
      }

      .span_t {
        width: 100px;
      }

      .item_li {
        width: 280px;
        margin-right: 5px;
      }

      .default_num {
        max-width: 260px;
        height: 15px;
        background-color: #e77d35;
        text-align: center;
      }
    }
  }

  .bg-color-black {
    // padding: 5px;
    height: 100%!important;
    // width: $box-width;
    border-radius: 10px;
    padding: 0 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .body-box {
    border-radius: 10px;
    overflow: hidden;
    padding-bottom: 0px;

    .dv-cap-chart {
      width: 100%;
      height: 160px;
    }
  }
  .jc-end{
    margin-bottom: 4px
  }
  .d-title{
    justify-content: space-between;
    flex: 0 0 32px;
    min-height: 32px;
  }
  .table-list{
    flex: 1 1 auto;
    min-height: 0;
    .top_scrap{
      width: 98%;
    }
  }
  .bfsl{
    width: 70%;
    text-align: right;
  }
  .fz17{
    font-size: 14px;
  }

  .title11{
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    flex: 0 0 44px;
    min-height: 44px;
  }
  .title22{
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .title33{
    flex: 0 0 34px;
    min-height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .item-li{
    .numWashing{
      display: inline-block;
      height: 22px;
    }
  }
}
.flexEnd{
  display: flex;
  flex-direction: row;
  justify-content: flex-end!important;
  width: 98%;
}
.hide{
  opacity: 0;
}


.warp {
  height: 100%;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    width: 100%;
    li,a {
      display: block;
      height: 28px;
      line-height: 28px;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      font-size: 15px;
      width: 100%;
      margin-bottom: 6px;
    }
    li{
      //border-bottom: 3px solid #1370fb;
    }
    .index{
      display: inline-block;
      width: 50%;
      overflow: hidden;
      white-space: nowrap;
      .orange{
        color:#e77d35;
        margin-bottom: 3px;
        display: flex;
        align-items: center;
        gap: 4px;
        width: 100%;
        overflow: hidden;
      }
      .name{
        flex: 1 1 auto;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
      }
      position: relative;
      span{
        color: #fff;display: inline-block;
      }
      .line{
        height: 6px; width:100%;background:#2d8cf0;display:inline-block;border-radius: 3px;
        position: absolute;
        bottom: 0;
        left: 0;
        min-width: 10%;
      }
    }
    .num{
      width: 25%;text-align: center;color: #00cdff;white-space:nowrap;
    }
    .numWashing{
      width: 25%;
      text-align: center;color: #00cdff;
    }
  }
}
.w50{
  width: 50%;
  text-align: center;
}
.w25{
  width: 25%;
  text-align: center;white-space:nowrap;
}
</style>


